import React from "react";
import "./spendanalyis-icon.css";

function SpendanalyisIcon() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="23.383"
        height="23.383"
        viewBox="0 0 23.383 23.383"
      >
        <defs></defs>
        <g transform="translate(1 1)">
          <ellipse
            className="spend"
            cx="10.692"
            cy="10.692"
            rx="10.692"
            ry="10.692"
          />
          <path
            className="spend"
            d="M113.392,99.7v10.692H102.7"
            transform="translate(-102.7 -99.7)"
          />
          <path
            className="spend"
            d="M258.5,121.08l-5.5,9.171,5.5,9.171"
            transform="translate(-242.308 -119.559)"
          />
        </g>
      </svg>
    </>
  );
}

export default SpendanalyisIcon;
